/**
 * Insert text at a specific cursor position with smart spacing
 *
 * @param currentText - The current text in the input
 * @param textToInsert - The text to insert
 * @param cursorPosition - Optional cursor position. If undefined, appends to end
 * @returns The new text with the inserted content
 */
export function insertTextAtCursor(
  currentText: string,
  textToInsert: string,
  cursorPosition?: number,
): string {
  if (cursorPosition !== undefined && cursorPosition >= 0) {
    // Insert at cursor position
    const before = currentText.slice(0, cursorPosition);
    const after = currentText.slice(cursorPosition);

    // Add space before if needed (cursor not at start and previous char isn't whitespace)
    const needsSpaceBefore = before.length > 0 && !/\s$/.test(before);
    // Add space after if needed (cursor not at end and next char isn't whitespace)
    const needsSpaceAfter = after.length > 0 && !/^\s/.test(after);

    return `${before}${needsSpaceBefore ? " " : ""}${textToInsert}${needsSpaceAfter ? " " : ""}${after}`;
  }

  // Append to end (backward compatible)
  return currentText.trim() ? `${currentText} ${textToInsert}` : textToInsert;
}
